/**
 * Standard Solution transaction type codes.
 */
export enum TransactionType {
    DEPOSIT = 'DEP',
    WITHDRAWAL = 'WD',
    COST = 'COST',
    INTEREST = 'INT',
    BUY = 'B',
    SELL = 'S',
    SUBSCRIPTION = 'SUB',
    REDEMPTION = 'RED',
    UNDEFINED = '',
}
